import { useEffect } from 'react';
import MontlyStatisticsLayout from 'components/Chart/MonthlyChart/MontlyStatisticsLayout';
import PersonnelStatisticsLayout from 'components/Chart/PersonnelStatistics/PersonnelStatisticsLayout';
import PostureStatisticsLayout from 'components/Chart/PostureStatistics/PostureStatisticsLayout';
import RomStatisticsLayout from 'components/Chart/RomStatistics/RomStatisticsLayout';
import Footer from 'components/Footer/Footer';
import Header from 'components/Header/Header';
import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { useNavigate } from 'react-router-dom';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import productAtom from 'atom/productAtom';
import companyIdxAtom from 'atom/companyIdxAtom';
import { QueryKeys, restfetcher } from 'queryClient';
import { useQuery } from '@tanstack/react-query';
import yearsListAtom from 'atom/yearsListAtom';
import companyInforAtom from 'atom/companyInforAtom';

const MainPages = () => {
  const companyInfor = useAtomValue(companyInforAtom);

  const getCenterInforData = useQuery({
    queryKey: [QueryKeys.CENTERINFOR],
    queryFn: () =>
      restfetcher({
        method: 'POST',
        path: 'dashboard/center/info',
        params: {
          centeridx: companyInfor.centeridx
        }
      })
  });

  const centerInforData: CenterInfor = getCenterInforData?.data;

  const navigate = useNavigate();
  const setProduct = useSetAtom(productAtom);
  const setCompanyIdx = useSetAtom(companyIdxAtom);
  const [yearsList, setYearsList] = useAtom(yearsListAtom);

  useEffect(() => {
    if (centerInforData) {
      const yearsOptions: number[] = centerInforData?.year || [];

      setProduct(centerInforData.product);
      setCompanyIdx(centerInforData.companyidx);
      setYearsList(yearsOptions);
    }
  }, [centerInforData]);

  // 1 - 스포츠  2 - 병원(양방,검진센터) 3 - 한의원용
  // 4 - 기업체  5 - 보건관리 6 - 연구용 7 - 요가, 필라테스 8 - 초등학교  9 - 고등학교 15 - 보건소

  // 기준은 5 - 보건관리

  useEffect(() => {
    if (companyInfor.centeridx !== 0) {
      getCenterInforData.refetch();
    }
  }, [companyInfor.centeridx]);

  useEffect(() => {
    if (!localStorage.getItem('refresh')) {
      navigate('/');
      localStorage.clear();
      sessionStorage.clear();
    }
  }, []);

  return (
    <Wrapper>
      {yearsList && <Header yearsList={yearsList} />}
      <MontlyStatisticsLayout />
      <PersonnelStatisticsLayout />
      <PostureStatisticsLayout />
      <RomStatisticsLayout />
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </Wrapper>
  );
};

export default MainPages;

const Wrapper = styled.div`
  width: 1280px;
  margin: 0 auto;
  padding: 0 32px;

  & .rom-layout > div {
    border: none;
  }
`;

const FooterWrapper = styled.div`
  width: 860px;
  margin: 0 auto;
  padding: 72px 0 120px;
  text-align: left;
  color: ${color.white06};
`;
